export const isStringNullOrEmpty = (value: string | null | undefined) => {
  if (!value) return true;
  return value.trim() === "";
};
